import Logo from './logo_trinco.jpg'
import Pesquisar from './pesquisar.png';
import BotaoApagar from './apagar.png';
import SemFoto from './sem_foto.jpg';
import SemFotoProduto from './sem_foto_produto.png';
import fotoLuizCaroline from './foto_luiz_caroline.jpg';
import fotoJuliana from './foto_juliana.jpg';
import fotoAlanFamilia from './foto_alan_familia.jpg';
import consertoRelogios from './conserto_relogio.png';
import copiaChaves from './copia_chaves.png';
import consertoCelular from './conserto_celular.png';
import gravacaoLaser from './gravacao_laser.png';
import reparoOculos from './reparo_oculos.png';
import confeccaoCarimbo from './confeccao_carimbo.png';
import funcionamentoRelogio from './funcionamento_relogio.png';
import pulseiraRelogio from './pulseira_relogio.png';
import vedacaoRelogio from './vedacao_relogio.png';
import chavesYaleTetra from './copia_chave.jpg';
import consertoFechadura from './manutencao_fechadura.png';
import chaveCarro from './chave_carro.png';
import trocaTelaCelular from './troca_tela_celular.png';
import limpezaConectorCelular from './limpeza_conector_celular.png';
import reparoPlacaCelular from './reparo_placa_celular.png';
import gravacaoCopoCaneta from './gravacao_copos.png';
import gravacaoPlacaOuro from './gravacao_placa_ouro.png';
import gravacaoVersatil from './gravacao_materiais.png';
import trocaMolasParafusosOculos from './troca_mola_parafuso_oculos.png';
import soldaCravejamentoOculos from './solda_cravejamento_oculos.png';
import manutencaoOculos from './manutencao_oculos.png';
import carimbosPadrao from './carimbos_padrao.png';
import carimboPocketTrocaResina from './carimbo_pocket.png';
import carimbosPersonalizados from './carimbo_personalizado.png';
import trabalheConosco from './trabalhe_nos.png';
import servicosJoias from './servico_joias.png';
import soldaJoias from './solda_joias.png';
import polimentoJoias from './polimento_aneis.png';
import ajusteJoias from './ajuste_aneis.png';
import manutencaoJoias from './manutencao_joias.png';
import servicosAfiacao from './servicos_afiacao.png';
import afiacaoTesouras from './afiacao_tesoura.png';
import afiacaoAlicates from './afiacao_alicate.png';
import afiacaoFacas from './afiacao_facas.png';
import servicosGravacaoManual from './gravacao_manual.png';
import gravacaoJoias from './gravacao_manual_joias.png';
import gravacaoInox from './gravacao_manual_diversos.png';
import gravacaoCopoMaterialEscolar from './gravacao_manual_copo.png';
import servicosEletronicos from './eletronicos.png';
import consertoControles from './conserto_controle_remoto.png';
import consertoCalculadoras from './conserto_calculadoras.png';
import consertoOutrosEletronicos from './pequenos_eletronicos.png';
import acessorioCelular from './acessorios_celular.png';
import chaveAcessorios from './chaves_acessorios.png';
import cozinha from './cozinha.png';
import comunicacao from './comunicacao.png';
import ferramentas from './ferramentas.png';
import informatica from './informatica.png';
import oculosAcessorios from './oculos_acessorios.png';
import relogiosAcessorios from './relogios_acessorios.png';
import bateriasPilhas from './baterias_pilhas.png';
import carimboAcessorios from './carimbos_acessorios.png';
import higieneCutelaria from './higene_cutelaria.png';
import presentePapelaria from './presente_papelaria.png';
import joiasAcessorios from './joias_acessorios.png';
import decoracoes from './decoracoes.png';
import coletaMotoboy from './coleta_motoboy.png';
import consertando from './consertando_relogio.png';
import devolvendo from './devovlendo_produto.png';
import suporteCelular from './suporte_celular.png';
import foneOuvido from './fone_ouvido.png';
import carregadorCelular from './carregador_celular.png';
import cabosUSB from './cabo_usb.png';
import pauSelfie from './pau_selfie.png';
import chaveiroDiversos from './chaveiros_diversos.png';
import cadeados from './cadeados.png';
import fechaduras from './fechaduras.png';
import eletroportateis from './eletroportateis.jpg';
import balancaTimers from './balanca_timers.png';
import capaJoias from './capa_joias.png';
import headerPilhas from './header_pilhas.png';
import headerBaterias from './header_baterias.png';
import headerCamping from './header_camping.png';
import headerTabacaria from './header_tabacaria.png';
import headerHigiene from './header_higiene.png';
import headerJogos from './header_jogos.png';
import headerInstrumentos from './header_instrumentos.png';
import headerPapelaria from './header_papelaria.png';
import balcaoTrinco from './balcao_trinco.png';
import carreiraTrinco from './carreira_trinco.png';
import oportunidadesTrinco from './oportunidades_trinco.png';
import reposicaoCelular from './reposicao_celular.png';
import pilhasAuditivo from './pilhas_auditivo.png';
import carregadoresBateria from './carregador_bateria.png';
import bateriasRelogios from './baterias_relogios.png';
import bateriaRecarregavel from './baterias_recarregaveis.png';
import carimboPersonalizado from './carimbo_personalizado_car.png';
import tintasAlmofadas from './tintas_almofadas.png';
import carimbosBolso from './carimbosBolso.png';
import audioSom from './audio_som.png';
import telefoniaComunicacao from './telefonia_comunicacao.png';
import controleAntenasTV from './controle_antena.png';
import estatuasEsculturas from './estatuas_esculturas.png';
import placasHomenagem from './placas_homenagem.png';
import ferramentasManuais from './ferramentas_manuais.png';
import mouseTeclados from './mouse_teclados.png';
import armazenamento from './armazenamento.png';
import fontesEnergia from './fontes_energia.png';
import hubsAdaptadores from './hubs_adaptadores.png';
import acessoriosPC from './acessorios_pc.png';
import encordoamento from './encordoamento.png';
import acessoriosMusicais from './acessorios_musicais.png';
import instrumentosMusicais from './instrumentos_musicais.png';
import oculosLeitura from './oculos_leitura.png';
import capasEstojos from './capas_estojos.png';
import acessoriosOculos from './acessorios_oculos.png';
import canetas from './canetas.png';
import carteirasAcessorios from './carteiras_acessorios.png';
import calculadoras from './calculadoras.png';
import presentesDecoracao from './presentes_decoracoes.png';
import relogiosPulsos from './relogios_pulsos.png';
import pulseirasPassadores from './pulseiras_passadores.png';
import relogiosParede from './relogios_parede.png';
import desperadores from './desperadores.png';
import cronometroTimers from './cronometro_timers.png';
import controleRemotos from './controle_remoto.png';
import cabosAdaptadores from './cabos_adaptadores.png';
import manicure from './manicure.png';
import tesourasCutelaria from './tesouras_cutelaria.png';
import cortadoresCutelaria from './cortadores_cutelaria.png';
import bateriasTelefone from './baterias_telefone.png';
import garrafaTermica from './garrafa_termica.png';
import coposTermicos from './copos_termicos.png';
import abridoresVinho from './abridores_vinho.png';
import ampulhetas from './ampulhetas.png';
import globos from './globos.png';
import cartasBaralho from './cartas_baralho.png';
import tabuleiro from './tabuleiro.png';
import bingo from './bingo.png';
import leituraLupa from './leitura_lupa.png';
import colaAdesivos from './cola_adesivos.png';
import identificacaoCrachas from './identificacao_cracha.png';
import acessoriosRelogios from './acessorios_relogios.png';
import binoculos from './binoculos.png';
import telescopios from './telescopios.png';
import bussolas from './bussolas.png';
import canivetes from './canivetes.png';
import maquinaCorte from './maquina_corte.png';
import aparadoresPelo from './aparador_pelo.png';
import espelhos from './espelhos.png';
import trenas from './trenas.png';
import macaricos from './macaricos.png';
import filtrosLinhas from './filtros_linhas.png';
import elosJoias from './elos_joias.png';
import fechesJoias from './feches_joias.png';
import limpezaJoias from './limpa_joias.png';
import pilhasRelogio from './pilhas_relogio.png';
import pilhasControle from './pilhas_controle.png';
import charutos from './charutos.png';
import fumos from './fumos.png';
import cachimbos from './cachimbos.png';
import tabacos from './tabacos.png';
import acessorioFumo from './acessorio_fumo.png';
import equipeTrinco from './equipe_trinco.png';
import carimbosDatador from './carimbos_datador.png';
import fogos from './fogos.png';
import tomadas from './tomadas.png';
import adaptadores from './adaptadores.png';
import distribuicao from './distribuicao.png';
import luminarias from './luminarias.png';

export const assets = {
  funcionamentoRelogio, equipeTrinco, reparoOculos, consertoRelogios, gravacaoLaser, consertoCelular, copiaChaves, fotoLuizCaroline, fotoAlanFamilia,
  fotoJuliana, SemFotoProduto, Logo, Pesquisar, BotaoApagar, chaveCarro, trocaTelaCelular, limpezaConectorCelular, reparoPlacaCelular,
  SemFoto, pulseiraRelogio, confeccaoCarimbo, vedacaoRelogio, chavesYaleTetra, consertoFechadura, gravacaoCopoCaneta, carimbosDatador,
  gravacaoPlacaOuro, gravacaoVersatil, trocaMolasParafusosOculos, soldaCravejamentoOculos, manutencaoOculos, carimbosPadrao, trenas,
  carimboPocketTrocaResina, carimbosPersonalizados, trabalheConosco, servicosJoias, soldaJoias, polimentoJoias, ajusteJoias, manutencaoJoias,
  servicosAfiacao, afiacaoTesouras, afiacaoAlicates, afiacaoFacas, servicosGravacaoManual, gravacaoJoias, gravacaoInox, gravacaoCopoMaterialEscolar,
  servicosEletronicos, consertoControles, consertoCalculadoras, consertoOutrosEletronicos, acessorioCelular, chaveAcessorios, cozinha, comunicacao,
  ferramentas, informatica, oculosAcessorios, relogiosAcessorios, bateriasPilhas, carimboAcessorios, higieneCutelaria, acessoriosPC,
  presentePapelaria, joiasAcessorios, decoracoes, coletaMotoboy, consertando, devolvendo, suporteCelular, foneOuvido, carregadoresBateria,
  carregadorCelular, cabosUSB, pauSelfie, chaveiroDiversos, cadeados, fechaduras, eletroportateis, encordoamento, garrafaTermica,
  balancaTimers, capaJoias, headerPilhas, headerBaterias, headerCamping, headerTabacaria, headerHigiene, headerJogos, headerInstrumentos,
  headerPapelaria, balcaoTrinco, carreiraTrinco, oportunidadesTrinco, reposicaoCelular, pilhasAuditivo, pilhasRelogio, fumos, fogos,
  bateriasRelogios, bateriaRecarregavel, telescopios, bussolas, pilhasControle, charutos, cachimbos, tabacos, acessorioFumo,
  carimboPersonalizado, tintasAlmofadas, carimbosBolso, audioSom, telefoniaComunicacao, controleAntenasTV, abridoresVinho,
  estatuasEsculturas, placasHomenagem, ferramentasManuais, tesourasCutelaria, cortadoresCutelaria, globos, filtrosLinhas, luminarias,
  mouseTeclados, armazenamento, fontesEnergia, hubsAdaptadores, maquinaCorte, aparadoresPelo, macaricos, fechesJoias, adaptadores,
  acessoriosMusicais, instrumentosMusicais, oculosLeitura, capasEstojos, acessoriosRelogios, elosJoias, limpezaJoias, tomadas,
  acessoriosOculos, canetas, carteirasAcessorios, calculadoras, presentesDecoracao, relogiosPulsos, colaAdesivos, canivetes,
  pulseirasPassadores, relogiosParede, desperadores, cronometroTimers, controleRemotos, cabosAdaptadores, manicure, bateriasTelefone,
  coposTermicos, ampulhetas, cartasBaralho, tabuleiro, bingo, leituraLupa, identificacaoCrachas, binoculos, espelhos, distribuicao
}

export const elementos = [
  //Trabalhe conosco
  { nome: "trabalho", rota: "/trabalhe_conosco" },
  { nome: "oportunidade", rota: "/trabalhe_conosco" },
  { nome: "rh", rota: "/trabalhe_conosco" },

  //Relogios
  { nome: "confecao de pinos", rota: "/servico_relogio" },
  { nome: "desmontagem", rota: "/servico_relogio" },
  { nome: "limpeza", rota: "/servico_relogio" },
  { nome: "protecao contra agua", rota: "/servico_relogio" },
  { nome: "reducao de pulseira", rota: "/servico_relogio" },
  { nome: "relogio", rota: "/servico_relogio" },
  { nome: "relogios", rota: "/servico_relogio" },
  { nome: "revisao geral", rota: "/servico_relogio" },
  { nome: "substituicao de borrachas", rota: "/servico_relogio" },
  { nome: "teste de pressao", rota: "/servico_relogio" },
  { nome: "troca de maquinas", rota: "/servico_relogio" },
  { nome: "vedacao de relogios", rota: "/servico_relogio" },

  //Servico de joias
  { nome: "acabamento", rota: "/servico_joias" },
  { nome: "ajuste", rota: "/servico_joias" },
  { nome: "aumento", rota: "/servico_joias" },
  { nome: "banho", rota: "/servico_joias" },
  { nome: "brilho", rota: "/servico_joias" },
  { nome: "joias", rota: "/servico_joias" },
  { nome: "polimento", rota: "/servico_joias" },
  { nome: "reducao", rota: "/servico_joias" },
  { nome: "solda", rota: "/servico_joias" },

  //Servico de celulares
  { nome: "atualizacao de software", rota: "/servico_celular" },
  { nome: "blindagem frontal", rota: "/servico_celular" },
  { nome: "cameras", rota: "/servico_celular" },
  { nome: "celular", rota: "/servico_celular" },
  { nome: "componente", rota: "/servico_celular" },
  { nome: "conserto", rota: "/servico_celular" },
  { nome: "limpeza técnica", rota: "/servico_celular" },
  { nome: "pelicula", rota: "/servico_celular" },
  { nome: "reparo de conectores", rota: "/servico_celular" },
  { nome: "reparo de placas", rota: "/servico_celular" },
  { nome: "substituicao de componentes", rota: "/servico_celular" },
  { nome: "troca de telas", rota: "/servico_celular" },

  //Gravação a laser
  { nome: "gravacao em aco aluminio", rota: "/gravacao_laser" },
  { nome: "gravacao aluminio", rota: "/gravacao_laser" },
  { nome: "gravacao em inox", rota: "/gravacao_laser" },
  { nome: "gravacao em ouro", rota: "/gravacao_laser" },
  { nome: "gravacao em prata", rota: "/gravacao_laser" },
  { nome: "gravacao laser", rota: "/gravacao_laser" },
  { nome: "homenagem", rota: "/gravacao_laser" },
  { nome: "ouro", rota: "/gravacao_laser" },
  { nome: "placas de homenagem", rota: "/gravacao_laser" },
  { nome: "placas em metal", rota: "/gravacao_laser" },
  { nome: "prata", rota: "/gravacao_laser" },

  //Servico de carimbos
  { nome: "carimbos", rota: "/servico_carimbos" },
  { nome: "carimbos automaticos", rota: "/servico_carimbos" },
  { nome: "carimbos datador", rota: "/servico_carimbos" },
  { nome: "carimbos manual", rota: "/servico_carimbos" },
  { nome: "carimbos numerador", rota: "/servico_carimbos" },
  { nome: "carimbos pocket", rota: "/servico_carimbos" },
  { nome: "Desenhos e símbolos", rota: "/servico_carimbos" },
  { nome: "Logotipos e assinaturas", rota: "/servico_carimbos" },
  { nome: "manutencao", rota: "/servico_carimbos" },
  { nome: "manutencao de carimbos", rota: "/servico_carimbos" },
  { nome: "Modelos", rota: "/servico_carimbos" },
  { nome: "troca de almofadas", rota: "/servico_carimbos" },
  { nome: "troca de borrachas", rota: "/servico_carimbos" },
  { nome: "troca de resina", rota: "/servico_carimbos" },

  //Gravação manual
  { nome: "aplicação iniciais", rota: "/gravacao_manual" },
  { nome: "gravacao em copos", rota: "/gravacao_manual" },
  { nome: "gravacao em inox", rota: "/gravacao_manual" },
  { nome: "Gravação em peças de ouro e prata", rota: "/gravacao_manual" },
  { nome: "gravação em itens escolares", rota: "/gravacao_manual" },
  { nome: "Joias", rota: "/gravacao_manual" },
  { nome: "material escolar", rota: "/gravacao_manual" },
  { nome: "metais diversos", rota: "/gravacao_manual" },
  { nome: "personalizacao de placas", rota: "/gravacao_manual" },

  //Serviços em chaves
  { nome: "ajuste de fechadura", rota: "/servico_chave" },
  { nome: "chaves", rota: "/servico_chave" },
  { nome: "chaves de carro", rota: "/servico_chave" },
  { nome: "Conserto de chave automotiva", rota: "/servico_chave" },
  { nome: "Cópias Yale e Tetra", rota: "/servico_chave" },
  { nome: "Cópias Tetra", rota: "/servico_chave" },
  { nome: "Cópia de chave automotiva", rota: "/servico_chave" },
  { nome: "Cópia de chave Yale", rota: "/servico_chave" },
  { nome: "Cópia de chave Tetra", rota: "/servico_chave" },
  { nome: "fechaduras", rota: "/servico_chave" },
  { nome: "instalacao de fechadura", rota: "/servico_chave" },
  { nome: "substituição de fechadura", rota: "/servico_chave" },
  { nome: "Troca de botões", rota: "/servico_chave" },
  { nome: "Troca de carcaça", rota: "/servico_chave" },
  { nome: "troca de segredo", rota: "/servico_chave" },

  //Serviços eletronicos
  { nome: "Calculadoras", rota: "/servico_eletronicos" },
  { nome: "Controle remoto", rota: "/servico_eletronicos" },
  { nome: "Correção de botões", rota: "/servico_eletronicos" },
  { nome: "Correção de funcionamento", rota: "/servico_eletronicos" },
  { nome: "Correção de teclas", rota: "/servico_eletronicos" },
  { nome: "eletronicos", rota: "/servico_eletronicos" },
  { nome: "Limpeza técnica", rota: "/servico_eletronicos" },
  { nome: "oxidacao", rota: "/servico_eletronicos" },
  { nome: "Outros Eletrônicos", rota: "/servico_eletronicos" },
  { nome: "placas", rota: "/servico_eletronicos" },
  { nome: "Remover sujeira", rota: "/servico_eletronicos" },
  { nome: "Remoção de sujeira", rota: "/servico_eletronicos" },

  //Servicos de afiação
  { nome: "Acabamento", rota: "/servico_afiacao" },
  { nome: "afiar", rota: "/servico_afiacao" },
  { nome: "Afiação de corte", rota: "/servico_afiacao" },
  { nome: "Afiação de lâminas", rota: "/servico_afiacao" },
  { nome: "Ajuste de lâminas", rota: "/servico_afiacao" },
  { nome: "Alicates", rota: "/servico_afiacao" },
  { nome: "Alinhamento", rota: "/servico_afiacao" },
  { nome: "Facas", rota: "/servico_afiacao" },
  { nome: "Polimento do fio", rota: "/servico_afiacao" },
  { nome: "Restauração do corte", rota: "/servico_afiacao" },
  { nome: "Tesouras", rota: "/servico_afiacao" },

  //Servico de oculos
  { nome: "Ajuste", rota: "/servico_oculos" },
  { nome: "Alinhamento", rota: "/servico_oculos" },
  { nome: "Correção das hastes", rota: "/servico_oculos" },
  { nome: "Cravejamento", rota: "/servico_oculos" },
  { nome: "Desempeno", rota: "/servico_oculos" },
  { nome: "oculos", rota: "/servico_oculos" },
  { nome: "Restauração", rota: "/servico_oculos" },
  { nome: "Solda em armações", rota: "/servico_oculos" },
  { nome: "Substituição dos parafusos da armação", rota: "/servico_oculos" },
  { nome: "Troca de molas", rota: "/servico_oculos" },
  { nome: "Troca de parafusos", rota: "/servico_oculos" },

  //Acessorios celular
  { nome: "audio", rota: "/produto_celular" },
  { nome: "bluetooth", rota: "/produto_celular" },
  { nome: "cabos usb", rota: "/produto_celular" },
  { nome: "carregador", rota: "/produto_celular" },
  { nome: "carro", rota: "/produto_celular" },
  { nome: "celular", rota: "/produto_celular" },
  { nome: "conexao", rota: "/produto_celular" },
  { nome: "energia", rota: "/produto_celular" },
  { nome: "fone de ouvido", rota: "/produto_celular" },
  { nome: "pau de selfie", rota: "/produto_celular" },
  { nome: "suportes", rota: "/produto_celular" },
  { nome: "tomada", rota: "/produto_celular" },
  { nome: "transferencia de dados", rota: "/produto_celular" },

  //baterias
  { nome: "aparelhos", rota: "/produto_baterias" },
  { nome: "balanças", rota: "/produto_baterias" },
  { nome: "Baterias recarregáveis", rota: "/produto_baterias" },
  { nome: "Baterias de Relógio", rota: "/produto_baterias" },
  { nome: "brinquedos", rota: "/produto_baterias" },
  { nome: "Carregadores", rota: "/produto_baterias" },
  { nome: "celulares", rota: "/produto_baterias" },
  { nome: "despertadores", rota: "/produto_baterias" },
  { nome: "eletronicos", rota: "/produto_baterias" },
  { nome: "paredes", rota: "/produto_baterias" },
  { nome: "pilhas", rota: "/produto_baterias" },
  { nome: "telefones", rota: "/produto_baterias" },

  //Aventura
  { nome: "aventura", rota: "/produto_aventura" },
  { nome: "binoculos", rota: "/produto_aventura" },
  { nome: "bussolas", rota: "/produto_aventura" },
  { nome: "camping", rota: "/produto_aventura" },
  { nome: "canivetes", rota: "/produto_aventura" },
  { nome: "cantil", rota: "/produto_aventura" },
  { nome: "cortes", rota: "/produto_aventura" },
  { nome: "expedicoes", rota: "/produto_aventura" },
  { nome: "facas esportivas", rota: "/produto_aventura" },
  { nome: "ferramentas", rota: "/produto_aventura" },
  { nome: "lanternas", rota: "/produto_aventura" },
  { nome: "observacoes", rota: "/produto_aventura" },
  { nome: "orientaçao", rota: "/produto_aventura" },
  { nome: "sobrevivencia", rota: "/produto_aventura" },
  { nome: "telescopios", rota: "/produto_aventura" },
  { nome: "trilhas", rota: "/produto_aventura" },

  //Carimbos
  { nome: "acessorios", rota: "/produto_carimbos" },
  { nome: "almofadas", rota: "/produto_carimbos" },
  { nome: "automaticos", rota: "/produto_carimbos" },
  { nome: "bolso", rota: "/produto_carimbos" },
  { nome: "carimbos de bolso", rota: "/produto_carimbos" },
  { nome: "carimbos personalizados", rota: "/produto_carimbos" },
  { nome: "compactos", rota: "/produto_carimbos" },
  { nome: "datadores", rota: "/produto_carimbos" },
  { nome: "movel", rota: "/produto_carimbos" },
  { nome: "tintas", rota: "/produto_carimbos" },
  { nome: "tinta interna", rota: "/produto_carimbos" },

  //Chaves
  { nome: "automotivo", rota: "/produto_chaves" },
  { nome: "cadeados", rota: "/produto_chaves" },
  { nome: "canivetes", rota: "/produto_chaves" },
  { nome: "chaveiro", rota: "/produto_chaves" },
  { nome: "chaves", rota: "/produto_chaves" },
  { nome: "chaves comerciais", rota: "/produto_chaves" },
  { nome: "chaves residenciais", rota: "/produto_chaves" },
  { nome: "cópias de carro", rota: "/produto_chaves" },
  { nome: "cópias de chaves", rota: "/produto_chaves" },
  { nome: "codificado", rota: "/produto_chaves" },
  { nome: "fechadura", rota: "/produto_chaves" },
  { nome: "segredo", rota: "/produto_chaves" },
  { nome: "tipos", rota: "/produto_chaves" },

  //Informática
  { nome: "acessorios", rota: "/produto_informatica" },
  { nome: "adaptadores", rota: "/produto_informatica" },
  { nome: "alimentacao", rota: "/produto_informatica" },
  { nome: "armazenamento", rota: "/produto_informatica" },
  { nome: "cabos e adaptadores", rota: "/produto_informatica" },
  { nome: "cartoes de memoria", rota: "/produto_informatica" },
  { nome: "cases", rota: "/produto_informatica" },
  { nome: "computação", rota: "/produto_informatica" },
  { nome: "computador", rota: "/produto_informatica" },
  { nome: "conexoes", rota: "/produto_informatica" },
  { nome: "energia", rota: "/produto_informatica" },
  { nome: "entradas", rota: "/produto_informatica" },
  { nome: "hds", rota: "/produto_informatica" },
  { nome: "hubs", rota: "/produto_informatica" },
  { nome: "fontes", rota: "/produto_informatica" },
  { nome: "informatica", rota: "/produto_informatica" },
  { nome: "mouses", rota: "/produto_informatica" },
  { nome: "notebook", rota: "/produto_informatica" },
  { nome: "pen drives", rota: "/produto_informatica" },
  { nome: "teclados", rota: "/produto_informatica" },

  //Sinal
  { nome: "antenas digitais hdtv", rota: "/produto_sinal" },
  { nome: "ar condicionado", rota: "/produto_sinal" },
  { nome: "audio e som", rota: "/produto_sinal" },
  { nome: "bluetooth", rota: "/produto_sinal" },
  { nome: "caixas de som", rota: "/produto_sinal" },
  { nome: "comunicacao", rota: "/produto_sinal" },
  { nome: "com fio", rota: "/produto_sinal" },
  { nome: "conectividade", rota: "/produto_sinal" },
  { nome: "controles", rota: "/produto_sinal" },
  { nome: "microfones", rota: "/produto_sinal" },
  { nome: "portateis", rota: "/produto_sinal" },
  { nome: "radios", rota: "/produto_sinal" },
  { nome: "residencia", rota: "/produto_sinal" },
  { nome: "sem fio", rota: "/produto_sinal" },
  { nome: "sinal", rota: "/produto_sinal" },
  { nome: "telefonia", rota: "/produto_sinal" },
  { nome: "transmissao sinal", rota: "/produto_sinal" },
  { nome: "transmissao sinais", rota: "/produto_sinal" },
  { nome: "universais", rota: "/produto_sinal" },
  { nome: "cabos", rota: "/produto_sinal" },
  { nome: "universal", rota: "/produto_sinal" },

  //Utensilios
  { nome: "abridores eletricos", rota: "/produto_utensilios" },
  { nome: "abridores manuais", rota: "/produto_utensilios" },
  { nome: "acendedores", rota: "/produto_utensilios" },
  { nome: "balancas digitais", rota: "/produto_utensilios" },
  { nome: "bebidas", rota: "/produto_utensilios" },
  { nome: "copos termicos", rota: "/produto_utensilios" },
  { nome: "cortadores", rota: "/produto_utensilios" },
  { nome: "cozinha", rota: "/produto_utensilios" },
  { nome: "garrafas termicas", rota: "/produto_utensilios" },
  { nome: "medicao", rota: "/produto_utensilios" },
  { nome: "medicoes", rota: "/produto_utensilios" },
  { nome: "termicos", rota: "/produto_utensilios" },
  { nome: "tesoura", rota: "/produto_utensilios" },
  { nome: "timers", rota: "/produto_utensilios" },
  { nome: "utensilios", rota: "/produto_utensilios" },

  //Cuidados pessoais
  { nome: "acessorios", rota: "/produto_cuidados_pessoais" },
  { nome: "aparadores", rota: "/produto_cuidados_pessoais" },
  { nome: "aparelho de barbear", rota: "/produto_cuidados_pessoais" },
  { nome: "balancas digitais", rota: "/produto_cuidados_pessoais" },
  { nome: "barbeador", rota: "/produto_cuidados_pessoais" },
  { nome: "bem-estar", rota: "/produto_cuidados_pessoais" },
  { nome: "bem estar", rota: "/produto_cuidados_pessoais" },
  { nome: "cuidados pessoais", rota: "/produto_cuidados_pessoais" },
  { nome: "espelhos com led", rota: "/produto_cuidados_pessoais" },
  { nome: "higiene", rota: "/produto_cuidados_pessoais" },
  { nome: "maquina de cortar cabelo", rota: "/produto_cuidados_pessoais" },
  { nome: "oculos de leitura", rota: "/produto_cuidados_pessoais" },
  { nome: "pelos", rota: "/produto_cuidados_pessoais" },
  { nome: "pessoa", rota: "/produto_cuidados_pessoais" },
  { nome: "retrateis", rota: "/produto_cuidados_pessoais" },
  { nome: "saude", rota: "/produto_cuidados_pessoais" },
  { nome: "visual", rota: "/produto_cuidados_pessoais" },

  //Cutelaria
  { nome: "agulhas", rota: "/produto_cutelaria" },
  { nome: "alicate de precisao", rota: "/produto_cutelaria" },
  { nome: "amoladores", rota: "/produto_cutelaria" },
  { nome: "cortador de unha", rota: "/produto_cutelaria" },
  { nome: "cortadores", rota: "/produto_cutelaria" },
  { nome: "costura e reparos", rota: "/produto_cutelaria" },
  { nome: "cutelaria", rota: "/produto_cutelaria" },
  { nome: "cuticula", rota: "/produto_cutelaria" },
  { nome: "kits de facas", rota: "/produto_cutelaria" },
  { nome: "kits prontos", rota: "/produto_cutelaria" },
  { nome: "linhas", rota: "/produto_cutelaria" },
  { nome: "manicure", rota: "/produto_cutelaria" },
  { nome: "roupas", rota: "/produto_cutelaria" },
  { nome: "tesouras e pinças", rota: "/produto_cutelaria" },

  //Decorações
  { nome: "adornos", rota: "/produto_decoracoes" },
  { nome: "ambiente", rota: "/produto_decoracoes" },
  { nome: "ampulhetas", rota: "/produto_decoracoes" },
  { nome: "decoracoes", rota: "/produto_decoracoes" },
  { nome: "enfeites", rota: "/produto_decoracoes" },
  { nome: "esculturas", rota: "/produto_decoracoes" },
  { nome: "estatuas", rota: "/produto_decoracoes" },
  { nome: "globos", rota: "/produto_decoracoes" },
  { nome: "mapas", rota: "/produto_decoracoes" },
  { nome: "mesa", rota: "/produto_decoracoes" },
  { nome: "placas de homenagem", rota: "/produto_decoracoes" },
  { nome: "tempo", rota: "/produto_decoracoes" },

  //Ferramentas
  { nome: "adaptadores", rota: "/produto_ferramentas" },
  { nome: "alicates", rota: "/produto_ferramentas" },
  { nome: "buxas", rota: "/produto_ferramentas" },
  { nome: "chaves de fenda", rota: "/produto_ferramentas" },
  { nome: "extensoes", rota: "/produto_ferramentas" },
  { nome: "ferramentas", rota: "/produto_ferramentas" },
  { nome: "ferramentas manuais", rota: "/produto_ferramentas" },
  { nome: "fixacao e ferragem", rota: "/produto_ferramentas" },
  { nome: "ganchos", rota: "/produto_ferramentas" },
  { nome: "kits", rota: "/produto_ferramentas" },
  { nome: "martelos", rota: "/produto_ferramentas" },
  { nome: "montagem", rota: "/produto_ferramentas" },
  { nome: "medicao", rota: "/produto_ferramentas" },
  { nome: "parafusos", rota: "/produto_ferramentas" },
  { nome: "rede eletrica", rota: "/produto_ferramentas" },
  { nome: "trenas", rota: "/produto_ferramentas" },
  { nome: "varal", rota: "/produto_ferramentas" },
  { nome: "varais", rota: "/produto_ferramentas" },

  //Instrumentos musicais
  { nome: "acessorios musicais", rota: "/produto_instrumentos" },
  { nome: "afinadores", rota: "/produto_instrumentos" },
  { nome: "bateria", rota: "/produto_instrumentos" },
  { nome: "cavaquinho", rota: "/produto_instrumentos" },
  { nome: "cordas pra violao", rota: "/produto_instrumentos" },
  { nome: "flautas", rota: "/produto_instrumentos" },
  { nome: "gaitas", rota: "/produto_instrumentos" },
  { nome: "guitarra", rota: "/produto_instrumentos" },
  { nome: "instrumentos musicais", rota: "/produto_instrumentos" },
  { nome: "palhetas", rota: "/produto_instrumentos" },
  { nome: "som", rota: "/produto_instrumentos" },
  { nome: "violao", rota: "/produto_instrumentos" },

  //Jogos
  { nome: "baralhos", rota: "/produto_jogos" },
  { nome: "bingos", rota: "/produto_jogos" },
  { nome: "cartas", rota: "/produto_jogos" },
  { nome: "controle de consoles", rota: "/produto_jogos" },
  { nome: "cubo magico", rota: "/produto_jogos" },
  { nome: "damas", rota: "/produto_jogos" },
  { nome: "dominos", rota: "/produto_jogos" },
  { nome: "games", rota: "/produto_jogos" },
  { nome: "jogos", rota: "/produto_jogos" },
  { nome: "lazer e estrategia", rota: "/produto_jogos" },
  { nome: "pokers", rota: "/produto_jogos" },
  { nome: "raciocinio", rota: "/produto_jogos" },
  { nome: "xadrez", rota: "/produto_jogos" },

  //Joias
  { nome: "acessorios", rota: "/produto_joias" },
  { nome: "brilho", rota: "/produto_joias" },
  { nome: "correntes", rota: "/produto_joias" },
  { nome: "dourado", rota: "/produto_joias" },
  { nome: "elos", rota: "/produto_joias" },
  { nome: "feches", rota: "/produto_joias" },
  { nome: "joias", rota: "/produto_joias" },
  { nome: "limpa joias", rota: "/produto_joias" },
  { nome: "limpezas", rota: "/produto_joias" },
  { nome: "ouro", rota: "/produto_joias" },
  { nome: "peças", rota: "/produto_joias" },
  { nome: "prata", rota: "/produto_joias" },
  { nome: "pulseiras", rota: "/produto_joias" },
  { nome: "pureza", rota: "/produto_joias" },
  { nome: "reparo", rota: "/produto_joias" },
  { nome: "tarrachas", rota: "/produto_joias" },

  //Óculos
  { nome: "acessorios", rota: "/produto_oculos" },
  { nome: "capas", rota: "/produto_oculos" },
  { nome: "estojos", rota: "/produto_oculos" },
  { nome: "graus", rota: "/produto_oculos" },
  { nome: "leitura", rota: "/produto_oculos" },
  { nome: "limpadores", rota: "/produto_oculos" },
  { nome: "modelos", rota: "/produto_oculos" },
  { nome: "nitidez", rota: "/produto_oculos" },
  { nome: "oculos", rota: "/produto_oculos" },
  { nome: "oculos de leitura", rota: "/produto_oculos" },
  { nome: "parafusos", rota: "/produto_oculos" },
  { nome: "plaquetas", rota: "/produto_oculos" },
  { nome: "protecao", rota: "/produto_oculos" },
  { nome: "suportes", rota: "/produto_oculos" },

  //Escritório
  { nome: "adesivos", rota: "/produto_escritorio" },
  { nome: "borrachas", rota: "/produto_escritorio" },
  { nome: "canetas", rota: "/produto_escritorio" },
  { nome: "cargas", rota: "/produto_escritorio" },
  { nome: "colas", rota: "/produto_escritorio" },
  { nome: "escritorio", rota: "/produto_escritorio" },
  { nome: "fitas", rota: "/produto_escritorio" },
  { nome: "fixacao", rota: "/produto_escritorio" },
  { nome: "grampeadores", rota: "/produto_escritorio" },
  { nome: "identificacao", rota: "/produto_escritorio" },
  { nome: "leitura", rota: "/produto_escritorio" },
  { nome: "lupas", rota: "/produto_escritorio" },
  { nome: "mimos", rota: "/produto_escritorio" },
  { nome: "papeis", rota: "/produto_escritorio" },
  { nome: "porta crachas", rota: "/produto_escritorio" },
  { nome: "porta identidade", rota: "/produto_escritorio" },
  { nome: "papelaria", rota: "/produto_escritorio" },
  { nome: "recargas", rota: "/produto_escritorio" },
  { nome: "reposicoes", rota: "/produto_escritorio" },

  //Pilhas
  { nome: "aaa", rota: "/produto_pilhas" },
  { nome: "aparelhos", rota: "/produto_pilhas" },
  { nome: "aparelho auditivo", rota: "/produto_pilhas" },
  { nome: "aparelhos auditivos", rota: "/produto_pilhas" },
  { nome: "balancas", rota: "/produto_pilhas" },
  { nome: "brinquedos", rota: "/produto_pilhas" },
  { nome: "controle remoto", rota: "/produto_pilhas" },
  { nome: "despertadores", rota: "/produto_pilhas" },
  { nome: "dispositivos eletronicos", rota: "/produto_pilhas" },
  { nome: "pilhas alcalinas", rota: "/produto_pilhas" },
  { nome: "pilhas recarregaveis", rota: "/produto_pilhas" },
  { nome: "relogios de parede", rota: "/produto_pilhas" },
  { nome: "relogios de pulso", rota: "/produto_pilhas" },

  //Presentes
  { nome: "acessorios", rota: "/produto_presente" },
  { nome: "calculadoras", rota: "/produto_presente" },
  { nome: "canetas", rota: "/produto_presente" },
  { nome: "carteiras de couro", rota: "/produto_presente" },
  { nome: "chaveiros", rota: "/produto_presente" },
  { nome: "decoracao", rota: "/produto_presente" },
  { nome: "placas de homenagem", rota: "/produto_presente" },
  { nome: "presente", rota: "/produto_presente" },

  //Relógios
  { nome: "acessorios", rota: "/produto_relogios" },
  { nome: "cabeceiras", rota: "/produto_relogios" },
  { nome: "cronometros", rota: "/produto_relogios" },
  { nome: "despertadores", rota: "/produto_relogios" },
  { nome: "mesa", rota: "/produto_relogios" },
  { nome: "modelos analogicos", rota: "/produto_relogios" },
  { nome: "modelos digitais", rota: "/produto_relogios" },
  { nome: "passadeiras", rota: "/produto_relogios" },
  { nome: "passadores", rota: "/produto_relogios" },
  { nome: "pinos", rota: "/produto_relogios" },
  { nome: "pulseiras", rota: "/produto_relogios" },
  { nome: "relogios de parede", rota: "/produto_relogios" },
  { nome: "relogios de pulso", rota: "/produto_relogios" },
  { nome: "relogio de parede", rota: "/produto_relogios" },
  { nome: "relogio de pulso", rota: "/produto_relogios" },
  { nome: "relogios de pulso", rota: "/produto_relogios" },
  { nome: "relogios de pulso", rota: "/produto_relogios" },
  { nome: "relogios de pulso", rota: "/produto_relogios" },
  { nome: "relogios de pulso", rota: "/produto_relogios" },
  { nome: "relogios musicais", rota: "/produto_relogios" },
  { nome: "smartwatches", rota: "/produto_relogios" },
  { nome: "timers", rota: "/produto_relogios" },

  //Tabacaria
  { nome: "acessorios", rota: "/produto_tabacaria" },
  { nome: "cachimbos", rota: "/produto_tabacaria" },
  { nome: "chama", rota: "/produto_tabacaria" },
  { nome: "charutos", rota: "/produto_tabacaria" },
  { nome: "cigarro", rota: "/produto_tabacaria" },
  { nome: "dichavadores", rota: "/produto_tabacaria" },
  { nome: "fluido", rota: "/produto_tabacaria" },
  { nome: "fogo", rota: "/produto_tabacaria" },
  { nome: "fumo", rota: "/produto_tabacaria" },
  { nome: "gas", rota: "/produto_tabacaria" },
  { nome: "isqueiro", rota: "/produto_tabacaria" },
  { nome: "maçaricos", rota: "/produto_tabacaria" },
  { nome: "piteiras", rota: "/produto_tabacaria" },
  { nome: "sedas", rota: "/produto_tabacaria" },
  { nome: "tabacaria", rota: "/produto_tabacaria" },
  { nome: "tabacos", rota: "/produto_tabacaria" },
]
